module.exports = __webpack_public_path__ + "media/images/warning-yellow-b58e233bb355cbf2044d5c690b4ea9f3.svg";